module.exports = __webpack_public_path__ + "img/s53.496d87aa.png";